import { NAVIGATION_BLUE, NAVIGATION_ORAGE, NAVIGATION_PINK, NAVIGATION_PURPLE } from "./colors";

/** Gruppo di navigazione della sidebar: usato sia per i gruppi del menu che per la badge dell'header delle pagine di dettaglio. */
export type NavigationGroupInfo = { titleKey: string; color: string };

export const NAV_GROUP_MAIN: NavigationGroupInfo = {
  titleKey: "navigation.main_pages",
  color: NAVIGATION_ORAGE
};

export const NAV_GROUP_MAINTENANCE: NavigationGroupInfo = {
  titleKey: "navigation.maintenance",
  color: NAVIGATION_PURPLE
};

export const NAV_GROUP_CONFIGURATION: NavigationGroupInfo = {
  titleKey: "navigation.configuration",
  color: NAVIGATION_BLUE
};

export const NAV_GROUP_SETTINGS: NavigationGroupInfo = {
  titleKey: "navigation.settings",
  color: NAVIGATION_PINK
};
